import "core-js/modules/es6.function.name";
import _objectSpread from "/data/jenkins/workspace/saas-prod_cp-fe-bms-web/node_modules/@babel/runtime-corejs2/helpers/esm/objectSpread2";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { setSchoolSubjectSave } from '@data/setting';
import { transferStudentInfo, getGradeClassList, saveStudentTransfer, gradeClassListByOrgCode } from '@data/student';
import { gender } from "../../../../utils/enumeration";
import { mapActions } from 'vuex';
export default {
  name: 'transfer-apply-dialog',
  props: {
    configObj: Object
  },
  data: function data() {
    // 设定单独的验证事件
    var checkFormItem = function checkFormItem(rule, value, callback) {
      if (rule.required != null && (value == null || value == '')) {
        // 验证非空
        callback(new Error('性别不能为空！'));
      } else {
        callback();
      }
    };

    return {
      showPage: 1,
      configVo: this.configObj,
      operationName: '学生转学申请',
      sexList: gender(),
      gradeList: [],
      // 年级列表
      classList: [],
      // 班级列表
      firstForm: {
        sid: '',
        // 特殊传值用
        name: '',
        sex: ''
      },
      // 弹出层可设置项表单字段定义
      firstFormRules: {
        sid: [{
          required: true,
          message: '学籍号不能为空!',
          trigger: 'blur'
        }, {
          pattern: /^\w{1,}$/,
          message: '输入数字或字母'
        }],
        name: [{
          required: true,
          message: '姓名不能为空！',
          trigger: 'blur'
        }, {
          pattern: /^[\S]{2,50}$/,
          message: '姓名输入在2~50个字！'
        }],
        sex: [{
          required: true,
          validator: checkFormItem,
          trigger: 'change'
        }]
      },
      secondForm: {
        studentId: '',
        orgName: '',
        termSettingName: '',
        gradeId: '',
        gradeName: '',
        classId: '',
        className: ''
      },
      thirdForm: {
        nowUserTermSettingId: 2085,
        nowUserTermSettingName: '2019春季',
        gradeId: '',
        classId: ''
      },
      thirdFormRules: {
        gradeId: [{
          required: true,
          message: '年级不能为空！',
          trigger: 'change'
        }],
        classId: [{
          required: true,
          message: '班级不能为空！',
          trigger: 'change'
        }]
      }
    };
  },
  mounted: function mounted() {},
  methods: _objectSpread({}, mapActions('user', {
    setUserAlert: 'setUserAlert' // 弹框提示

  }), {
    // 第一步 下一步按钮
    nextStepFirstFn: function nextStepFirstFn() {
      var _this = this;

      var params = {
        sid: this.firstForm.sid,
        name: this.firstForm.name,
        sex: this.firstForm.sex
      };
      this.$refs.firstForm.validate(function (result) {
        if (result) {
          _this.transferStudentPromise(params).then(function (data) {
            if (data.messageInfo == 1) {
              _this.setUserAlert({
                flag: true,
                type: 'info',
                text: data.message
              });
            } else {
              if (data.student && data.student.orgCode === _this.tools.getLocalStorage('userInfo').orgCode) {
                _this.setUserAlert({
                  flag: true,
                  type: 'info',
                  text: _this.msg.WARNING_93
                });
              } else {
                _this.secondForm.orgName = data.orgName;
                _this.secondForm.termSettingName = data.termSettingName;
                _this.secondForm.classId = data.classId;
                _this.secondForm.studentId = data.student.id;
                _this.secondForm.gradeId = data.gradeId;
                _this.secondForm.gradeName = data.gradeName;
                _this.secondForm.classId = data.student.classId;
                _this.secondForm.className = data.className;
                _this.secondForm.orgCode = data.student.orgCode;
                _this.thirdForm.nowUserTermSettingId = data.nowUserTermSettingId;
                _this.thirdForm.nowUserTermSettingName = data.nowUserTermSettingName;
                _this.showPage = 2;
              }
            }
          });
        } else {
          _this.$notify.info('请按照规则填写数据');
        }
      });
    },
    // 第二步 上一步按钮
    PrevStepSecondFn: function PrevStepSecondFn() {
      this.showPage = 1;
    },
    // 第二步 下一步按钮
    nextStepSecondFn: function nextStepSecondFn() {
      var _this2 = this;

      getGradeClassList().then(function (res) {
        var data = res;
        _this2.gradeList = data; // 年级列表
      }).catch(function () {});
      this.showPage = 3;
    },
    // 第三步 上一步按钮
    PrevStepThirdFn: function PrevStepThirdFn() {
      this.showPage = 2;
    },
    // 第三步 下一步按钮
    nextStepThirdFn: function nextStepThirdFn() {
      var _this3 = this;

      var self = this;
      var params = {
        studentID: this.secondForm.studentId,
        // 学生id
        destOrgCode: this.tools.getLocalStorage('userRole').orgCode,
        // 转入学校code
        destGradeId: this.thirdForm.gradeId,
        // 转入年级
        destGradeName: this.thirdForm.gradeName,
        // 转入年级name
        destClassId: this.thirdForm.classId,
        // 转入班级
        destClassName: this.thirdForm.className,
        // 转入班级name
        destSchoolTermId: this.thirdForm.nowUserTermSettingId,
        // 转入学校学期id
        destSchoolTermName: this.thirdForm.nowUserTermSettingName,
        // 转入学校学期name
        transferTime: this.tools.getDate(new Date().getTime())
      };

      if (this.firstForm.index) {
        params.index = this.firstForm.index;
      }

      console.log(this.thirdForm);
      self.$refs.thirdForm.validate(function (result) {
        if (result) {
          saveStudentTransfer(params).then(function (res) {
            var obj = {
              flag: false
            };

            _this3.setUserAlert({
              flag: true,
              type: 'success',
              text: _this3.msg.WARNING_86
            });

            _this3.$emit('close', obj);
          }).catch(function (rej) {
            _this3.setUserAlert({
              flag: true,
              type: 'error',
              text: rej.message
            });
          });
        } else {
          _this3.$notify.info('请按照规则填写数据');
        }
      });
    },
    // 切换年级
    gradeFn: function gradeFn() {
      var _this4 = this;

      this.thirdForm.classId = '';
      this.classList = this.gradeList.filter(function (item) {
        return item.id === _this4.thirdForm.gradeId;
      })[0].schoolClassList;
    },
    // 获取学生信息
    transferStudentPromise: function transferStudentPromise(params) {
      var p = new Promise(function (resolve, reject) {
        transferStudentInfo(params).then(function (res) {
          resolve(res);
        }).catch(function (rej) {
          reject(rej);
        });
      });
      return p;
    },
    // 弹框关闭前回调
    cancel: function cancel() {
      this.configVo.dialog = false;
    },
    checkIsNull: function checkIsNull(fieldVal) {
      return undefined === fieldVal || null === fieldVal || '' === fieldVal;
    }
  })
};